import { render, staticRenderFns } from "./ServiceRequestDetail.vue?vue&type=template&id=ee8f617e&scoped=true&"
import script from "./ServiceRequestDetail.vue?vue&type=script&lang=js&"
export * from "./ServiceRequestDetail.vue?vue&type=script&lang=js&"
import style0 from "./ServiceRequestDetail.vue?vue&type=style&index=0&id=ee8f617e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee8f617e",
  null
  
)

export default component.exports